import { GoogleGenerativeAI } from "@google/generative-ai";

const googleai = new GoogleGenerativeAI("AIzaSyBHpYHtnkuWSVRUjDJfXi3gQ2Jsobzg_Xc");

export class Assistant {
    // #chat;
        #chat = null;

    name = "googleai";

        constructor(model = "gemini-1.5-flash") {
        const gemini = googleai.getGenerativeModel({ model });
        this.#chat = gemini.startChat({ history: [] });

    }



      async createChat(history) {
        // const model = googleai.getGenerativeModel({ model: "gemini-pro" });
        const model = googleai.getGenerativeModel({ model: "gemini-1.5-flash" });
    this.#chat = await model.startChat({
      history: history
        .filter(({ role }) => role !== "system")
        .map(({ content, role }) => ({
          parts: [{ text: content }],
          role: role === "assistant" ? "model" : role,
        })),
    });
  }

//MY VERSION
    // createChat(history) {
    //     this.#chat = googleai.chats.create({
    //         model: this.#chat.model,
    //         history: history
    //         .filter(({ role }) => role !== "system")
    //         .map(({ content, role }) => ({
    //             parts: [{text: content}],
    //             role: role === "assistant" ? "model" : role,
    //         })),
    //     });
    // }
    async chat(content) {
        try {
            const result = await this.#chat.sendMessage(content);
            return result.response.text();
        } catch (error) {
            throw error;
        }
    }
}